export const SITE_URL = "https://tribebeachkos.gr";

export const SEO = {
  en: {
    path: "/",
    lang: "en",
    locale: "en_GB",
    title: "Tribe Beach Lounge | Beach Bar, Lounges & Water Sports in Tigaki, Kos",
    description:
      "Tribe Beach Lounge in Tigaki, Kos — a family-friendly beach lounge open to everyone. Free sunbeds (minimum consumption), free water sports (SUP & kayak), self-drive boat rental, beach spa, snacks & cocktails. Open daily till late.",
    h1: "Tribe Beach Lounge – Beach Bar & Lounges in Tigaki, Kos",
  },
  de: {
    path: "/de/",
    lang: "de",
    locale: "de_DE",
    title: "Tribe Beach Lounge | Beach-Bar, Lounges & Wassersport in Tigaki, Kos",
    description:
      "Tribe Beach Lounge in Tigaki, Kos — eine familienfreundliche Beach-Lounge für alle. Kostenlose Liegen (Mindestverzehr), kostenloser Wassersport (SUP & Kajak), Bootsverleih ohne Führerschein, Beach-Spa, Snacks & Cocktails. Täglich bis spät geöffnet.",
    h1: "Tribe Beach Lounge – Beach-Bar & Lounges in Tigaki, Kos",
  },
  el: {
    path: "/el/",
    lang: "el",
    locale: "el_GR",
    title: "Tribe Beach Lounge | Beach Bar, Lounges & Θαλάσσια Σπορ στο Τιγκάκι, Κως",
    description:
      "Tribe Beach Lounge στο Τιγκάκι της Κω — οικογενειακό beach lounge ανοιχτό για όλους. Δωρεάν ξαπλώστρες (ελάχιστη κατανάλωση), δωρεάν θαλάσσια σπορ (SUP & καγιάκ), ενοικίαση σκάφους χωρίς δίπλωμα, beach spa, snacks & κοκτέιλ. Ανοιχτά κάθε μέρα ως αργά.",
    h1: "Tribe Beach Lounge – Beach Bar & Lounges στο Τιγκάκι της Κω",
  },
  book: {
    path: "/book",
    lang: "en",
    locale: "en_GB",
    title: "Book a Lounge, Massage or Padel | Tribe Beach Lounge, Tigaki, Kos",
    description:
      "Reserve your lounge or umbrella at Tribe Beach Lounge in Tigaki, Kos — sunbeds are free with a minimum consumption. Book a beach massage or padel court online with instant confirmation.",
    h1: "Book your spot at Tribe Beach Lounge, Tigaki, Kos",
    intro:
      "Reserve a lounge or umbrella on the sand (free sunbeds, minimum consumption only), a beach massage or a padel court. Choose your service, pick a date and time and get instant confirmation by email.",
  },
};

export const HOME_LANGS = ["en", "de", "el"];

export const hreflangLinks = () => [
  ...HOME_LANGS.map((k) => ({ hreflang: k, href: SITE_URL + SEO[k].path })),
  { hreflang: "x-default", href: SITE_URL + "/" },
];
